import { render, staticRenderFns } from "./SurveyWaitingPlayers.vue?vue&type=template&id=0c74d780"
import script from "./SurveyWaitingPlayers.vue?vue&type=script&lang=js"
export * from "./SurveyWaitingPlayers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports